import { faMinus, faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function renderTokenIndicator(operators) {
    if (operators.length !== 1) {
        return null;
    }
    if (operators[0] === "=") {
        return (<div className="include"><FontAwesomeIcon icon={faPlus} /></div>);
    }
    if (operators[0] === "!=") {
        return (<div className="exclude"><FontAwesomeIcon icon={faMinus} /></div>);
    }
    return null;
}

export function getSelectedCategoriesAndOperators(qualifiers) {
    return qualifiers.value.map((q) => {
        const uniqueOperators = [...new Set(q.values.map((obj) => obj.operator))];
        return { category: q.category, operators: uniqueOperators };
    });
}
